module.exports = __webpack_public_path__ + "img/headBg-lazy1.03cd38d2.jpg";